export default class Colour {
    static averageColour(leftColour, rightColour, ratio) {
        const r = Math.ceil(parseInt(rightColour.substring(1,3), 16) * ratio + parseInt(leftColour.substring(1,3), 16) * (1-ratio));
        const g = Math.ceil(parseInt(rightColour.substring(3,5), 16) * ratio + parseInt(leftColour.substring(3,5), 16) * (1-ratio));
        const b = Math.ceil(parseInt(rightColour.substring(5,67), 16) * ratio + parseInt(leftColour.substring(5,7), 16) * (1-ratio));

        return Colour.hex(r) + Colour.hex(g) + Colour.hex(b);
    }

    static hex (_colour) {
        const colour = _colour.toString(16);
        return (colour.length === 1) ? `0${colour}` : colour;
    };
}